import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import FlexRow from "../../../components/base/FlexRow";
import ScrollContainer from "../../../components/base/ScrollContainer";
import Section from "../../../components/base/Section";
import Layout from "../../../components/layouts/Layout";
import ReportsSideMenu, { useReportsSideMenuItems } from "./ReportsSideMenu";
import { clearPageName, setPageTitleTap, useScreen } from "../../../core/Global";
import PageTitleBar from "../../../components/layouts/header/PageTitleBar";
import { getFirstAccessibleLink, useModuleLastPage } from "../../../components/layouts/aside/useModuleLastPage";
import ModuleSidebar from "../../../components/layouts/aside/ModuleSidebar";
import ReportsMobileSheet from "./ReportsMobileSheet";


export default function ReportsMainView() {

    const screen = useScreen()
    const location = useLocation()
    const sideMenuItems = useReportsSideMenuItems()
    const defaultLink = getFirstAccessibleLink(sideMenuItems, "/reports/jobs/dispatcher") ?? "/reports/jobs/dispatcher"
    useModuleLastPage("/reports/jobs", defaultLink)

    const [sheetOpen, sheetOpenSet] = useState(false)

    useEffect(() => {
        return () => {
            clearPageName()
        }
    }, [location.pathname])

    // On mobile the report/segment switcher lives in an iOS-style bottom sheet opened by
    // tapping the header title (each report page sets that title via setPage).
    useEffect(() => {
        if (!screen.isMobile) return
        setPageTitleTap(() => sheetOpenSet(true))
        return () => setPageTitleTap(undefined)
    }, [screen.isMobile])

    const isJobsReport = location.pathname.toLowerCase().startsWith("/reports/jobs")

    return (
        <Layout wide noToolbar paddingBottom={0} paddingTop={0}>
            <Section fluid fit>
                <FlexRow alignItems="start">

                    {
                        !screen.isMobile &&
                        <ModuleSidebar storageKey="rinvox-sidebar-collapsed-reports">
                            <ReportsSideMenu />
                        </ModuleSidebar>
                    }

                    <div className="flex-row-fluid">

                        {!isJobsReport && <PageTitleBar />}

                        <ScrollContainer>
                            <Outlet />
                        </ScrollContainer>

                    </div>

                </FlexRow>

                {screen.isMobile && <ReportsMobileSheet open={sheetOpen} onClose={() => sheetOpenSet(false)} />}

            </Section>
        </Layout>
    )
}
